"use client"

import { useAtomValue } from "jotai"
import type React from "react"
import { privacyConsentAtom } from "./atom"

interface WithPrivacyGuardProps {
	children: React.ReactNode
	fallback?: React.ReactNode
}

// 高阶组件：只有在用户同意隐私协议后才渲染子组件
export function WithPrivacyGuard({
	children,
	fallback = null,
}: WithPrivacyGuardProps) {
	const hasConsent = useAtomValue(privacyConsentAtom)

	if (!hasConsent) {
		return <>{fallback}</>
	}

	return <>{children}</>
}

// Hook：获取隐私协议同意状态
export function usePrivacyConsent() {
	return useAtomValue(privacyConsentAtom)
}
